import { Link } from 'react-router-dom';
import { categories } from '@/mocks/manga';

export default function CategorySection() {
  const displayCategories = categories.filter((c) => c.slug !== 'all');

  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            <strong>韩漫分类</strong>浏览
          </h2>
          <p className="text-sm text-foreground-500 mt-1">按类型筛选，快速找到你喜欢的韩国漫画</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3 md:gap-4">
          {displayCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-4 md:p-5 bg-background-50 rounded-xl hover:bg-primary-50 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-primary-100 rounded-xl group-hover:bg-primary-500 transition-all">
                <i className={`${cat.icon} text-xl md:text-2xl text-primary-600 group-hover:text-background-50 transition-all`}></i>
              </div>
              <div className="text-center">
                <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  {cat.name}
                </span>
                <p className="text-xs text-foreground-400 mt-0.5">{cat.count}部</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}